export default "__VITE_ASSET__3ec8bca2__"